import { Vue, Prop, Component } from 'vue-property-decorator';
import { InputValidation } from '../../../helpers/inputValidation';
import { CampaignParameter, ICampaignParameter, IFormatParameter, IAssetParameterValue } from '@models';
import { cloneDeep, tap } from 'lodash';
import { Notification } from '../../../helpers/Notification';


@Component
export default class CampaignParametersFormTypeBase extends Vue {
    name = 'campaign-parameters-form-type-base';
    input = InputValidation;
    notification = new Notification();
    inputKey: number = 0;

    jsonValue: IAssetParameterValue;

    @Prop({
        type: Object as () => ICampaignParameter,
        required: true,
    }) value: ICampaignParameter;

    @Prop({
        type: Object as any,
        required: false,
        default: null
    }) initialValue;

    @Prop({
        type: Object as () => IFormatParameter,
        required: true,
    }) formatParameter: IFormatParameter;

    get local(): ICampaignParameter {
        return this.value ? this.value : new CampaignParameter({ tag: 'N/A', value: 'N/A', file: null, campaignId: null, id: null, formatParameterId: this.formatParameter.id, formatParameter: this.formatParameter, canvasContentId: null  });
    }

    updateValue(key, value) {
        this.$emit('input', tap(cloneDeep(this.local), v => v[key] = value));
    }

    update(callback: (v: ICampaignParameter) => void = (v) => { }): void {
        this.$emit('input', tap(cloneDeep(this.local), v => callback(v)));
    }

    reset(callback: (v: ICampaignParameter) => void = (v) => { }): void {
        this.$emit('input', tap(cloneDeep(this.initialValue), v => callback(v)));
    } 
}
